"use client";
import CustomCarousel from "../CustomCarousel/CustomCarousel.js";
import VideoCard from "../VideoCard/VideoCard";
import { useIntl } from "react-intl";
import { useState, useEffect } from "react";
import Link from "next/link";
import "./TestimonialVideos.scss";

export default function TestimonialVideos({ data, heading }) {
  const intl = useIntl();
  const [activeVideoId, setActiveVideoId] = useState(null);

  useEffect(() => {
    // Optional: client-only logic can go here
  }, []);

  // Check if this is the package details page
  const isPackageDetails = heading === "Success Stories from Our Patients";

  return (
    <section className="-mt-8 pt-2 pb-0 sm:mt-0 sm:pt-4 sm:pb-0 md:-mt-8 md:pb-2 w-full">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-2">
        {isPackageDetails ? (
          <h2 className="font-poppins text-[24px] sm:text-[28px] md:text-[32px] leading-none tracking-wider text-center mb-6 sm:mb-8">
            <span className="font-[275]">Success Stories from Our </span>
            <span className="text-[#006DAF] font-normal">Patients</span>
          </h2>
        ) : (
          <>
            <h2 className="font-roboto-slab text-[34px] sm:text-[30px] md:text-[30px] font-medium text-center mb-6 sm:mb-8">
              <span className="text-[#00428A]">
                {intl.formatMessage({
                  id: "patientTestimonials.families",
                  defaultMessage: "Families",
                })}
              </span>{" "}
              <span className="text-[#404248] font-light">
                {intl.formatMessage({
                  id: "patientTestimonials.likeYours",
                  defaultMessage: "like yours",
                })}
              </span>
            </h2>
            <p className="font-roboto text-[20px] font-light text-center text-[#404248] mb-6 sm:mb-8">
              {intl.formatMessage({
                id: "patientTestimonials.description",
                defaultMessage: "People who once felt unsure — sharing how they found clarity and support",
              })}
            </p>
          </>
        )}

        <div className="testimonialVideosCarousel w-full">
          <CustomCarousel
            itemsPerPage={3}
            previousButtonClassName="xl:-left-[60px] lg:-left-[56px] -left-[60px] translate-x-1/2"
            nextButtonClassName="xl:-right-[30px] lg:-right-[36px] -right-[20px] translate-x-1/2"
          >
            {data?.testimonialvideos?.map((video) => (
              <div
                key={video.id}
                className="testimonialVideoItem h-full w-full flex justify-center"
              >
                <VideoCard
                  video={video}
                  isActive={activeVideoId === video.id}
                  onPlay={() => setActiveVideoId(video.id)}
                  className="testimonialVideoCard h-auto w-full"
                />
              </div>
            ))}
          </CustomCarousel>
        </div>
        <div className="flex justify-center mt-4">
          <Link href="/testimonial-videos">
            <button className="inline-block w-auto px-10 py-2 text-[#00428A] hover:text-[#005A8E] text-[14px] font-semibold transition duration-200 border border-[#00428A] rounded-md hover:bg-[#00428A] hover:text-white mb-6">
              {intl.formatMessage({ id: "viewAllBtn" })}
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}
